import { checkDomain } from './checkDomain';

export const ENV = {
  isDev: 'dev' === checkDomain(),
  isStage: 'stage' === checkDomain(),
  isProd: 'prod' === checkDomain(),
};
